import React, { memo, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { AppSidebar } from "./index";
import { SidebarProvider } from "@/contexts/SidebarContext";
import { cn } from "@/lib/utils";

const PersistentLayout = memo(({ children }: { children: React.ReactNode }) => {
  const location = useLocation();

  // Memoizar la lógica del sidebar para evitar recálculos
  const showSidebar = useMemo(() => {
    const hideSidebarRoutes = [
      "/welcome",
      "/terms",
      "/not-registered",
      "/user-deactivated",
    ];
    return !hideSidebarRoutes.includes(location.pathname);
  }, [location.pathname]);

  return (
    <SidebarProvider>
      <div className="flex h-screen overflow-hidden">
        {/* Sidebar persistente - sin re-mount entre navegaciones */}
        {showSidebar && (
          <div className="fixed top-0 left-0 z-40 h-screen">
            <AppSidebar />
          </div>
        )}

        {/* Contenido principal con animación optimizada */}
        <div
          className={cn(
            "flex flex-col flex-1 overflow-hidden transition-all duration-200",
            showSidebar ? "md:ml-[240px] ml-14" : "ml-0",
          )}
        >
          <main className="flex-1 overflow-auto">
            <div className="h-full">{children}</div>
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
});

PersistentLayout.displayName = "PersistentLayout";

export default PersistentLayout;
